<div class="container-fluid section pt-3 pb-2">
    <span class="header">Booking requests</span>
    <div *ngIf="bookingRequests.length" class="content mt-3">
        <div class="sub-section py-2 px-3 mb-2" *ngFor="let booking of bookingRequests; let i = index">
            <div class="d-flex flex-row justify-content-between">
                <span class="sub-title">Due on: {{booking.mumRequested[0]?.dueDate | date:'EEE dd MMM yyyy'}}</span>
                <div class="fas mt-1 collapsed" data-toggle="collapse" [attr.data-target]="'#collapse-ap-' + i"></div>
            </div>
            <div [attr.id]="'collapse-ap-' + i" class="collapse">
                <div class="horizontal-line my-2"></div>
                <div class="d-flex flex-row">
                    <img class="profile-img" *ngIf="booking.mumRequested[0].profileImage"
                        [src]="booking.mumRequested[0].profileImage">
                    <img class="profile-img" *ngIf="!booking.mumRequested[0].profileImage"
                        src="../../../../../../assets/Images/pro-pic.png">
                    <span class="title ml-3 mt-2" *ngIf="booking.mumRequested">{{booking.mumRequested[0]?.name}}</span>
                </div>
                <div class="d-flex flex-row mt-3 mb-2">
                    <i class="fas fa-phone icon phone"></i>
                    <span class="section-text ml-3"
                        *ngIf="booking.mumRequested">{{booking.mumRequested[0].user[0]?.userPhonenumber}}</span>
                </div>
                <div class="d-flex flex-row my-2">
                    <i class="fas fa-envelope icon"></i>
                    <span class="section-text ml-3"
                        *ngIf="booking.mumRequested">{{booking.mumRequested[0].user[0]?.userEmail}}</span>
                </div>
                <div class="d-flex flex-row my-2">
                    <i class="fas fa-map-marker-alt icon pl-1"></i>
                    <span class="section-text ml-3"
                        *ngIf="booking.mumRequested">{{booking.mumRequested[0]?.address}}</span>
                </div>
                <div class="d-flex flex-row justify-content-end mt-3 mb-2">
                    <button class="btn btn-theme mr-2" data-toggle="modal"
                        data-target="#approve-booking-dates" (click)="selectBooking(booking)">Approve</button>
                    <button class="btn btn-cancel" (click)="declineRequest(booking)">Decline</button>
                </div>
            </div>
        </div>
    </div>
    <div class="no-data" *ngIf="!bookingRequests.length">
        <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50" width="80"
            alt="No Appointment Requests">
        <span>No appointment requests</span>
    </div>
</div>

<app-booking-modal [bookingReq]="selectedBooking" (approved)="bookingApproved($event)"></app-booking-modal>